import type { TotalsBlock } from "@platform/api";

export const editTotalsBlock = (
  existingBlocks: TotalsBlock[],
  blockId: string,
  name: string,
  coverageIds: string[],
): TotalsBlock[] =>
  existingBlocks.map((block) => {
    if (block.id !== blockId) return block;

    return {
      ...block,
      name,
      coverages: coverageIds.map((coverageId, index) => ({
        coverageId,
        order: index,
      })),
    };
  });
